import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';
import { gridColumn, gridRow } from 'styleUtils/grid';

export const ImageGalleryWrapper = styled.div`
    position: relative;
    padding-top: 1.5rem;

    ${fromLarge`
        display: flex;
        align-items: center;
        ${gridColumn({ start: 2 })}
        ${gridRow({ start: 1 })}
    `};
`;
